import Skeleton from 'react-loading-skeleton';
import styled from 'styled-components';

export const StyledDiv = styled.div`
  flex-basis: 40em;
`;

export const QuoteRealtimeFormSidePanelSkeleton = () => {
  return (
    <StyledDiv className="flex-shrink-0 d-flex flex-column bg-lvl1 h-100 w-100">
      <div className="p-3">
        <h1>
          <Skeleton width="5em" />
        </h1>
      </div>
    </StyledDiv>
  );
};
